import { Collapse, CollapseProps } from '@mui/material'
import React, { FC } from 'react';

const CollapseWrapper: FC<CollapseProps> = ({...props}) => <Collapse {...props}/>

export default CollapseWrapper;
